let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7GLMy")).then(() => parcelRequire('6ZlQ1'));